import { render } from "./AllEvaluationTypes.vue?vue&type=template&id=13e052ec"
import script from "./AllEvaluationTypes.vue?vue&type=script&lang=js"
export * from "./AllEvaluationTypes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__